import {createContext} from 'react';
export const OverviewControls=createContext({available:false,requestId:0,requestEdit:()=>{}});
